export const PHONE_REGEX = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{6,32}$/
export const NUMBERS_ONLY_REGEX = /^\d+$/
export const NUMBERS_WITH_OPTIONAL_DECIMALS_REGEX = /^\d+(\.\d+)?$/
